import { Form, Formik } from "formik";
import { Link, useSearchParams } from "react-router-dom";

import TagImage from "../../Assets/images/logo.svg";

import { Button } from "primereact/button";
import { useContext, useEffect, useState } from "react";
import * as Yup from "yup";
import DropdownComponent from "../../Components/Dropdown";
import TextInput from "../../Components/TextInput";
import PasswordInput from "../../Components/TextPassword";
import LoginProvider, { LoginContext } from "../../Context/Login/context";
import { LoginContextText } from "../../Context/Login/types";
import { controllerYears } from "../../Controller/controllerYears";
import { idUser, login, logout, setYear } from "../../Services/localstorage";
import { Padding, Row } from "../../Styles/styles";
import { ContainerLogin } from "./styles";

const Login = () => {
  return (
    <LoginProvider>
      <LoginPage />
    </LoginProvider>
  );
};

const MICROSOFT_ERROR_MESSAGES: Record<string, string> = {
  email_not_registered:
    "Seu e-mail não está cadastrado no Meuben. Solicite ao administrador que cadastre seu e-mail no seu perfil.",
  email_not_found:
    "Não foi possível obter o e-mail da sua conta Microsoft. Tente novamente.",
  microsoft_context_expired:
    "Não foi possível concluir o acesso com a Microsoft. Tente entrar novamente.",
};

const LoginPage = () => {
  const props = useContext(LoginContext) as LoginContextText;
  const [searchParams] = useSearchParams();

  const years = controllerYears();
  const [year, setYearState] = useState<number>(years.currentYear);
  const [microsoftError, setMicrosoftError] = useState<string | null>(null);

  const LoginSchema = Yup.object().shape({
    password: Yup.string().required("Campo Obrigatório"),
    username: Yup.string().required("Campo Obrigatório"),
  });

  useEffect(() => {
    setYear(years.currentYear.toString());
  }, [years.currentYear]);

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (token) {
      logout();
      login(token);
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        if (payload?.sub) idUser(payload.sub);
      } catch {
        // payload inválido — token ainda é salvo
      }
      window.location.replace("/");
      return;
    }

    if (error) {
      setMicrosoftError(
        MICROSOFT_ERROR_MESSAGES[error] ?? "Erro ao autenticar com Microsoft."
      );
    }
  }, [searchParams]);

  const handleMicrosoftLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_PATH}auth/microsoft`;
  };

  return (
    <ContainerLogin>
      <div className="grid h-full">
        <div
          // style={{
          //   display: "flex",
          //   flexDirection: "column",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   height: "100%",
          //   width: "100%",
          //   position: "relative",
          // }}
          className="col-12 lg:col-5 loginColumn"
        >
          <Row style={{ justifyContent: "center" }}>
            <div className="resetPassword textCenter">
              <div className="buttonLogin">
                Faça sua matrícula
                <Link className="link" to="/register">
                  clique aqui
                </Link>
              </div>
            </div>
          </Row>
          <div className="loginPanelBody">
            <div className="col-11 md:col-9 loginContent">
              {/* <div className={classes.marginMobile20} /> */}
              <Row className="loginLogo" style={{ justifyContent: "center" }}>
                <img src={TagImage} alt="MeuBen"></img>
              </Row>

              <section
                className="microsoftAccess"
                aria-labelledby="microsoft-login-title"
              >
                <span className="recommendedAccess">Acesso recomendado</span>
                <h1 id="microsoft-login-title">
                  Entre com sua conta Microsoft
                </h1>
                <p>
                  Acesse o MeuBen de forma rápida e segura com sua conta
                  institucional.
                </p>
                <button
                  className="microsoftLoginButton"
                  type="button"
                  onClick={handleMicrosoftLogin}
                >
                  <span className="microsoftMark" aria-hidden="true">
                    <span className="microsoftRed" />
                    <span className="microsoftGreen" />
                    <span className="microsoftBlue" />
                    <span className="microsoftYellow" />
                  </span>
                  <span>Entrar com Microsoft</span>
                  <i className="pi pi-arrow-right" aria-hidden="true" />
                </button>
                {microsoftError && (
                  <div className="microsoftError" role="alert">
                    <i
                      className="pi pi-exclamation-circle"
                      aria-hidden="true"
                    />
                    <span>{microsoftError}</span>
                  </div>
                )}
              </section>

              <div className="loginDivider" aria-hidden="true">
                <span>ou entre com seu acesso MeuBen</span>
              </div>

              <Formik
                initialValues={props.initialValue}
                onSubmit={(values) => {
                  props.Login(values);
                }}
                validationSchema={LoginSchema}
                validateOnChange={false}
              >
                {({ values, errors, handleChange, touched }) => {
                  return (
                    <Form className="localLoginForm">
                      <div>
                        <div>
                          <label>Usuário</label>
                          <Padding />
                          <TextInput
                            name="username"
                            value={values.username}
                            onChange={handleChange}
                            placeholder="Usuário"
                          />
                          <Padding />
                          {errors.username && touched.username ? (
                            <div style={{ color: "red", marginTop: "8px" }}>
                              {errors.username}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="p-2" />
                      <div>
                        <div>
                          <label>Senha</label>
                          <Padding />
                          <PasswordInput
                            name="password"
                            placeholder="Senha"
                            onChange={handleChange}
                            value={values.password}
                          />
                          <Padding />
                          {errors.password && touched.password ? (
                            <div style={{ color: "red", marginTop: "8px" }}>
                              {errors.password}
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <Padding />
                      <div>
                        <div>
                          <label>Ano</label>
                          <Padding />
                          <DropdownComponent
                            options={years.yearsOptions}
                            placerholder="Ano"
                            onChange={(e) => {
                              setYearState(e.target.value);
                              setYear(e.target.value.toString());
                            }}
                            optionsLabel="value"
                            optionsValue="value"
                            value={year}
                          />
                        </div>
                      </div>
                      <Padding />

                      {props.error ? (
                        <div>
                          <div>
                            {!props.error ? "Usuário ou senha inválido" : ""}
                          </div>
                        </div>
                      ) : null}
                      <div className="p-2" />
                      <div>
                        <div>
                          <Button
                            className="localLoginButton"
                            type="submit"
                            label="Entrar com usuário e senha"
                          />
                        </div>
                      </div>
                      <div className="p-2" />
                      <div className="accessHelpActions">
                        <Link to="/solicitar-acesso">Preciso de ajuda para acessar</Link>
                        <Link to="/acompanhar-solicitacao">Acompanhar minha solicitação</Link>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
        <div className="col-0 lg:col-7 w-auto">
          <div className="imgBack">
            <div className="divBlue" />
            <div className="formSignUp">
              <div className="TextLarge">
                Maximizando Eficiência <br />e Transparência
              </div>
              <Padding padding="8px" />
              <Row id="center" style={{ width: "65%" }}>
                <p className="pLogin">
                  Solução completa para otimizar a distribuição de benefícios,
                  promover a transparência e fortalecer a confiança das
                  comunidades nos programas do THP.
                </p>
              </Row>
            </div>
          </div>
        </div>
      </div>
    </ContainerLogin>
  );
};

export default Login;
